import { Attr, BelongsTo, Model } from 'spraypaint';

import { ApplicationRecord } from './application_record';
import ClientUserAssignment from './client_user_assignment';
import User from './user';

@Model()
export default class LdapNameChange extends ApplicationRecord {
  static jsonapiType = 'ldap_name_changes';
  @Attr() name: string;
  @BelongsTo() user: User;
  @BelongsTo() clientUserAssignment: ClientUserAssignment;
}
